export const GET_FX_CALENDAR_INFO = "GET_FX_CALENDAR_INFO";
export const GET_FX_CALENDAR_INFO_SUCCESS = "GET_FX_CALENDAR_INFO_SUCCESS";
export const GET_FX_CALENDAR_INFO_ERROR = "GET_FX_CALENDAR_INFO_ERROR";

export const POST_FX_DATE = "POST_FX_DATE";
export const POST_FX_DATE_SUCCESS = "POST_FX_DATE_SUCCESS";
export const POST_FX_DATE_ERROR = "POST_FX_DATE_ERROR";
